import css from 'styled-jsx/css';
import { colors } from '../../../themes';

export default css`
  .snack {
    background: ${colors.grayDeep};
    bottom: 0;
    box-shadow: 0 -2px 2px 0 rgba(0, 0, 0, 0.1);
    transform: translateY(100%);
    color: #fff;
    padding: 20px 15px;
    position: fixed;
    width: 100%;
    transition: transform 0.15s ease-in-out;
    will-change: transform;
    line-height: 1.5;
    z-index: 9990;
  }

  .snack.showing {
    transform: translateY(0);
  }

  p {
    margin: 0;
    padding: 5px 0;
  }

  a {
    color: ${colors.blueLight};
    float: right;
    font-size: 1em; /* 16/16 */
    font-weight: bold;
    text-transform: uppercase;
    margin-left: 10px;
    padding: 5px;
    white-space: nowrap;
    display: inline-block;
  }

  :global(.rtl) a {
    float: left;
  }
`;



// WEBPACK FOOTER //
// ./app/components/mobile/SnackError/styles.js